import { yup } from '@framework/validation/initYup.ts';
import { unionSchema } from '@framework/validation/union/unionSchema.ts';
import { ExpressionType } from '../../IExpression.ts';
import { ConditionExpressionType } from '../condition/ConditionExpression.type.ts';
import { FunctionExpressionType } from '../function/FunctionExpression.type.ts';
import {
  ConditionGroupOperator,
  type IConditionGroupExpression,
  type IConditionItem,
} from './IConditionGroupExpression.ts';

export const ConditionGroupExpressionSchema: yup.ObjectSchema<IConditionGroupExpression> =
  yup
    .object({
      type: yup
        .string()
        .exact(ExpressionType.ConditionGroup)
        .required()
        .label('Tipo di condizione')
        .transform(() => ExpressionType.ConditionGroup),
      operator: yup
        .string()
        .oneOfEnum(ConditionGroupOperator)
        .default(ConditionGroupOperator.And)
        .label('Operazione')
        .required(),
      conditions: yup
        .array<any, IConditionItem>(
          yup.lazy(
            () =>
              unionSchema([
                ConditionGroupExpressionSchema,
                ConditionExpressionType.schema,
                FunctionExpressionType.schema,
              ]) as yup.Lazy<IConditionItem>,
          ),
        )
        .default([])
        .label('Condizioni')
        .required(),
    })
    .meta({ expression: ExpressionType.ConditionGroup });
